export function LandingPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        minHeight: '100dvh',
        background: 'linear-gradient(155deg, #07070d 0%, #0b0b16 35%, #080812 100%)',
        fontFamily: '"DM Sans", sans-serif',
        color: '#e8e4dc',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflowX: 'hidden',
        padding: 'clamp(24px, 5vh, 40px) 24px',
        gap: 'clamp(24px, 5vh, 48px)',
      }}
    >
      {/* Ambient orbs */}
      <div
        style={{
          position: 'fixed',
          top: '15%',
          left: '8%',
          width: 500,
          height: 500,
          background: 'radial-gradient(circle, rgba(255,107,43,.025) 0%, transparent 60%)',
          pointerEvents: 'none',
          animation: 'drift 25s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'fixed',
          bottom: '10%',
          right: '5%',
          width: 400,
          height: 400,
          background: 'radial-gradient(circle, rgba(78,205,196,.02) 0%, transparent 60%)',
          pointerEvents: 'none',
          animation: 'drift2 30s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'fixed',
          top: '40%',
          left: '50%',
          width: 600,
          height: 600,
          transform: 'translate(-50%, -50%)',
          background: 'radial-gradient(circle, rgba(167,139,250,.015) 0%, transparent 55%)',
          pointerEvents: 'none',
        }}
      />

      {/* Content */}
      <div style={{ textAlign: 'center', zIndex: 1, maxWidth: 480, width: '100%' }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 'clamp(16px, 3vh, 32px)' }}>
          <span
            style={{
              color: '#ff6b2b',
              fontSize: 'clamp(20px, 4vw, 28px)',
              animation: 'breathe 4s ease-in-out infinite',
              lineHeight: 1,
            }}
          >
            ●
          </span>
          <span
            style={{
              fontFamily: '"Space Mono", monospace',
              fontSize: 'clamp(24px, 5vw, 32px)',
              fontWeight: 700,
              letterSpacing: 6,
              color: '#e8e4dc',
            }}
          >
            pulse
          </span>
        </div>

        {/* Tagline */}
        <p
          style={{
            fontFamily: '"DM Sans", sans-serif',
            fontSize: 'clamp(18px, 3.5vw, 22px)',
            color: '#888',
            lineHeight: 1.6,
            marginBottom: 'clamp(24px, 4vh, 48px)',
            fontWeight: 400,
            letterSpacing: 0.3,
          }}
        >
          Every pause says something.
        </p>

        {/* Create button */}
        <a
          href="/new"
          style={{
            display: 'inline-block',
            fontFamily: '"Space Mono", monospace',
            fontSize: 14,
            fontWeight: 700,
            letterSpacing: 2,
            textTransform: 'lowercase',
            color: '#ff6b2b',
            background: 'rgba(255, 107, 43, 0.08)',
            border: '1px solid rgba(255, 107, 43, 0.2)',
            borderRadius: 10,
            padding: '16px 40px',
            textDecoration: 'none',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(255, 107, 43, 0.14)';
            e.currentTarget.style.borderColor = 'rgba(255, 107, 43, 0.35)';
            e.currentTarget.style.boxShadow = '0 0 30px rgba(255, 107, 43, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(255, 107, 43, 0.08)';
            e.currentTarget.style.borderColor = 'rgba(255, 107, 43, 0.2)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          create a pulse
        </a>
      </div>

      {/* Demo iframe in phone frame */}
      <div
        style={{
          zIndex: 1,
          width: 'min(320px, 85vw)',
          aspectRatio: '320 / 580',
          maxHeight: '60vh',
          borderRadius: 'clamp(20px, 5vw, 32px)',
          border: '2px solid rgba(255,255,255,.06)',
          overflow: 'hidden',
          boxShadow: '0 0 60px rgba(0,0,0,.5), 0 0 120px rgba(255,107,43,.03)',
          background: '#07070d',
          position: 'relative',
        }}
      >
        {/* Notch */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 100,
            height: 22,
            background: '#07070d',
            borderRadius: '0 0 14px 14px',
            zIndex: 2,
          }}
        />
        <iframe
          src="/demo"
          title="pulse demo"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: 'clamp(18px, 4.5vw, 30px)',
          }}
        />
      </div>

      {/* Subtext */}
      <p
        style={{
          fontFamily: '"Space Mono", monospace',
          fontSize: 'clamp(9px, 2vw, 11px)',
          color: '#333',
          letterSpacing: 1.5,
          zIndex: 1,
        }}
      >
        share the link · watch words form · let them fade
      </p>

      {/* Footer links */}
      <p
        style={{
          fontFamily: '"Space Mono", monospace',
          fontSize: 'clamp(9px, 2vw, 10px)',
          color: '#222',
          letterSpacing: 1,
          zIndex: 1,
        }}
      >
        <a href="/terms" style={{ color: '#333', textDecoration: 'none' }}>terms</a>
        {' · '}
        <a href="/privacy" style={{ color: '#333', textDecoration: 'none' }}>privacy</a>
        {' · '}
        <a href="/credits" style={{ color: '#333', textDecoration: 'none' }}>credits</a>
      </p>
    </div>
  );
}
